import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

interface TrendDataPoint {
  date: string;
  sales: number;
  lastYearSales: number;
  orders: number;
  avgOrder: number;
}

interface SalesTrendResponse {
  range: string;
  period: string;
  startDate: string;
  endDate: string;
  data: TrendDataPoint[];
}

export const useSalesTrend = (range: '7d' | '30d' | '90d' | '12m' = '7d', storeId?: string) => {
  return useQuery<SalesTrendResponse>({
    queryKey: ['sales-trend', range, storeId],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append('range', range);
      if (storeId) {
        params.append('storeId', storeId);
      }

      const response = await axios.get(`${API_BASE_URL}/sales/trend?${params.toString()}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};
